import { handleError } from 'common/utils/util.errors';
import React from 'react';
import { useQuery } from 'react-query';
import { useNavigate, useParams } from 'react-router-dom';
import { LinearProgress } from '@mui/material';
import keys from 'common/react-query/data-keys';
import { ROUTES } from 'common/constants/urls';
import { useAppContext } from 'common/AppContext';
import { getQCCReport } from '../components/quarterly-cc-report/quarterly-cc-report.api';
import { QCCReportWrapper } from '../components/quarterly-cc-report/QCCReportWrapper';

const QCCReport: React.FC = () => {
  const navigate = useNavigate();
  const { setPageHeaderText } = useAppContext();
  const { reportId } = useParams();
  const {
    data: report,
    isLoading,
    isError,
    error,
  } = useQuery([keys.qccReport, reportId], () => getQCCReport(reportId ?? ''), {
    enabled: !!reportId,
  });

  React.useEffect(() => {
    if (report && report.name) {
      setPageHeaderText(report.name);
    }
    return () => {
      setPageHeaderText('');
    };
  }, [setPageHeaderText, report?.name]);

  if (!reportId) {
    navigate(ROUTES.NOT_FOUND);
    return null;
  }

  if (isError) {
    handleError(error);
    navigate(ROUTES.NOT_FOUND);
    return null;
  }
  if (isLoading) return <LinearProgress />;
  if (!report) {
    navigate(ROUTES.NOT_FOUND);
    return null;
  }

  return <QCCReportWrapper initialReport={report} />;
};

export default QCCReport;
